import React, { Component } from "react";

import axios from "axios";
import { Spinner } from "../components/Spinner";

import { Grid } from "@material-ui/core/";
import { Container } from "reactstrap";

import DoNotDisturbDataTable from "../components/DoNotDisturbDataTable";

import DoNotDisturbAddForm from "../components/DoNotDisturbAddForm";
import DoNotDisturbAddMultipleForm from "../components/DoNotDisturbAddMultipleForm";

import { Alert } from "reactstrap";

import { LoggedUserContext } from "../LoggedUserContext";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { acquireToken } from "../adalConfig";

const MySwal = withReactContent(Swal);

export default class DoNotDisturbContainer extends Component {
  state = {
    items: [],
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });

    await acquireToken().then(async (token) => {
      let first = [];
      let url = `${process.env.REACT_APP_API_URL}/ExcludedEmailAPI/GetExcludedEmails/true`;
      await axios
        .get(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          if (res.data.code === 0) {
            first = res.data.items;
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the users",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the users",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });

      url = `${process.env.REACT_APP_API_URL}/ExcludedEmailAPI/GetExcludedEmails/false`;
      await axios
        .get(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          if (res.data.code === 0) {
            let items = first.concat(res.data.items);
            this.setState({ items: items, loading: false });
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the users",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the users",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });
    });
  }

  render() {
    const { loading, items } = this.state;
    return loading ? (
      <div>
        <Alert color="primary" fade={true}>
          This operation might take a moment.
        </Alert>
        <Spinner />
      </div>
    ) : (
      <div>
        <Grid
          container
          direction="column"
          justify="space-between"
          alignItems="stretch"
          spacing={2}
        >
          <Grid item>
            <Container>
              <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
              >
                <Grid item></Grid>
                <Grid item>
                  <Container>
                    <form>
                      <Grid
                        container
                        direction="row"
                        justify="flex-end"
                        alignItems="center"
                        spacing={2}
                      >
                        <Grid item>
                          <DoNotDisturbAddMultipleForm />
                        </Grid>
                        <Grid item>
                          <DoNotDisturbAddForm />
                        </Grid>
                      </Grid>
                    </form>
                  </Container>
                </Grid>
              </Grid>
            </Container>
          </Grid>

          <Grid item xs={12}>
            <Container>
              <DoNotDisturbDataTable data={items} />
            </Container>
          </Grid>
        </Grid>
      </div>
    );
  }
}

DoNotDisturbContainer.contextType = LoggedUserContext;
